<template>
	<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
		<div style="padding-button: 15px;">
			<grid></grid>
			<list :v-model="list" :refresh="isLoading" @reSuccess="onLoad"></list>
		</div>
	</van-pull-refresh>
</template>

<script>
import grid from "./components/grid";
import list from "./components/list";
import { post } from "@/api/post";

export default {
	name: "home",
	components: { grid, list },
	data() {
		return {
			list: {
				text: "",
				list: []
			},
			isLoading: false
		};
	},
	mounted() {
		this.getList();
	},
	methods: {
		getList() {
			post({
				requestType: "home_statistics_data"
			})
				.then(res => {
					this.list = res.obj;
					this.list.text = res.obj.notice_list[0].notice_content;
					this.list.list = res.obj.upcoming_list;
				})
				.catch(() => {
					console.log("数据异常");
				});
		},
		onRefresh() {
			this.isLoading = true;
		},
		onLoad() {
			this.isLoading = false;
		}
	}
};
</script>

<style lang="scss" scoped ></style>
